<template>
    <div>
        <app-sub-title text="Gestión de opciones de menús" />
        <b-button variant="primary" @click="startSaveMenuOption"><i class="fa fa-plus"></i> Crear menú</b-button>
        <app-menu-option-filters @filter="onFilter" />
        <app-menu-options-list
            :data="data"
            :on-change-page="onChangePage"
            @remove-menu="startRemoveMenu"
        />

        <!-- Inicio pop up's -->
        <app-pop-up title="Formulario" id="menu-form" :onClose="cleanForm">
            <div class="body" slot="body">
                <app-menu-option-form
                    :onSave="onSave"
                />
            </div>
            <div slot="buttons">
                <b-button variant="primary" :disabled="inProgress" @click="$bus.$emit('menu-form.save')"><i class="fa fa-floppy-o"> Guardar</i></b-button>
            </div>
        </app-pop-up>

        <app-pop-up title="Confirmación" id="menu-remove">
            <div slot="body"><h2>¿Esta seguro que desea eliminar este menú?</h2></div>
            <div class="buttons" slot="buttons">
                <b-button variant="confirm" @click="removeMenu"><i class="fa fa-trash-o"> Confirmar Eliminación</i></b-button>
            </div>
        </app-pop-up>
        <!-- Fin pop up's -->
    </div>
</template>

<script>
import MenuOptionsList from './MenuOptionsList/MenuOptionList.vue';
import MenuOptionForm from './MenuOptionsForm/MenuOptionForm.vue';
import MenuOptionFilters from './MenuOptionFilters/MenuOptionFilters.vue';
import permissionManagerRepository from '../../../repositories/permissionManager.repository.js';
export default {
    components: {
        appMenuOptionsList: MenuOptionsList,
        appMenuOptionForm: MenuOptionForm,
        appMenuOptionFilters: MenuOptionFilters
    },

    data(){
        return{
            data: '',
            page: 1,
            menuOptionSelect: '',
            filters: null
        }
    },

    methods: {
        loadMenuOptions(){
            const pmr = {...permissionManagerRepository};
            pmr.getMenuOptions(this.filters, this.page)
            .then(data => this.data = data)
            .catch(error => toastr.error('Ocurrió un error al cargar las opciones de menú'));
        },
        onChangePage(page){
            this.page = page;
            this.loadMenuOptions();
        },
        onFilter(filters){
            this.filters = filters;
            this.page = 1;
            this.loadMenuOptions();
        },
        startSaveMenuOption(){
            this.$bus.$emit('menu-form.open');
        },
        onSave() {
            this.$bus.$emit('menu-form.close');
            this.loadMenuOptions();
        },
        cleanForm() {
            this.$bus.$emit('menu-form.clean');
        },
        startRemoveMenu(menuOption){
            this.menuOptionSelect = menuOption;
            this.$bus.$emit('menu-remove.open');
        },
        removeMenu(){
            const pmr = {...permissionManagerRepository};
            pmr.deleteMenuOption(this.menuOptionSelect.id)
            .then(data => {
                if(data.status){
                    toastr.success(data.msg);
                    this.loadMenuOptions();
                    this.$bus.$emit('menu-remove.close');
                }else{
                    toastr.error(data.msg);
                }
            })
            .catch(error => {
                toastr.error('Error al borrar el menú');
            });
        }
    },

    created(){
        this.loadMenuOptions();
    }
}
</script>
